import React from 'react';
import { Heart, Crown, Briefcase, Landmark, Building2, Sparkles, Camera, Video } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  heart: Heart,
  crown: Crown,
  briefcase: Briefcase,
  landmark: Landmark,
  building2: Building2,
  sparkles: Sparkles
};

const Services = ({ services }) => {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-50/40 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <Camera className="h-4 w-4" />
            Nos Services
          </div>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            Une Couverture Complète pour
            <span className="bg-gradient-to-r from-amber-600 to-amber-500 bg-clip-text text-transparent"> Chaque Événement</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            De la photographie artistique aux vidéos cinématographiques, nous capturons l'essence de vos moments les plus précieux.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-500 border-0 bg-white/80 backdrop-blur-sm hover:-translate-y-2 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300">
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  <CardTitle className="text-2xl font-bold group-hover:text-amber-600 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Features Highlight */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 rounded-3xl p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <Camera className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-3 text-gray-900">Photographie Professionnelle</h3>
                <p className="text-gray-700 leading-relaxed">
                  Équipements haut de gamme, techniques artistiques et attention aux détails pour des images qui racontent votre histoire.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 rounded-3xl p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <Video className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-3 text-gray-900">Vidéographie Cinématographique</h3>
                <p className="text-gray-700 leading-relaxed">
                  Production vidéo de qualité cinéma avec montage professionnel pour revivre vos moments encore et encore.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
